import Vue from 'vue'
import VueI18n, { LocaleMessages } from 'vue-i18n'
import 'moment/locale/it'
import 'moment/locale/zh-cn'

Vue.use(VueI18n)
const SUPPORTED_LOCALES = [
  'en',
  'it',
  'cn'
]

export function getBrowserLocale(options = {}): string {
  const defaultOptions = { 
    countryCodeOnly: false 
  }
  const opt = { ...defaultOptions, ...options }

  const navigatorLocale =
    navigator.languages !== undefined
      ? navigator.languages[0]
      : navigator.language

  if (!navigatorLocale) {
    return ''
  }

  const trimmedLocale = opt.countryCodeOnly
    ? navigatorLocale.trim().split(/-|_/)[0]
    : navigatorLocale.trim()

  return trimmedLocale
}

function loadLocaleMessages (): LocaleMessages {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages: LocaleMessages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

const numberFormats = {
  'en': {
    currency: {
      style: 'currency', currency: 'EUR'
    }
  },
  'it': {
    currency: {
      style: 'currency', currency: 'EUR'
    }
  },
  'cn': {
    currency: {
      style: 'currency', currency: 'EUR'
    }
  }
}

const DEFAULT_LOCALE = getBrowserLocale({ countryCodeOnly: true })

const i18n = new VueI18n({
  locale: SUPPORTED_LOCALES.includes(DEFAULT_LOCALE) ? DEFAULT_LOCALE : 'it',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'it',
  messages: loadLocaleMessages(),
  numberFormats
})

export function getformattedLocale () {
  switch (i18n.locale) {
    case "en": return 'en'
    case "cn": return 'zh-cn'
    default: return 'it'
  }
}

export default i18n